import { useCallback, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useCurrentJob, useCurrentJobLead } from 'hooks';
import type { CheckoutFinanceRate } from 'pages/Quote/components/Rates/constants';

import {
  getIsPreApproved,
  getMaxCreditLine,
  getMaxDurationLabel,
} from './helpers';

export interface APRLineItemHook {
  selected: boolean;
  onClick: () => void;
  maxCreditLine: number;
  maxDuration: string;
  isPreApproved: boolean;
}

export default function useAPRLineItem(
  value: string,
  rates: CheckoutFinanceRate[],
): APRLineItemHook {
  const { setValue } = useFormContext();
  const [interest] = useWatch({
    name: ['interest'],
  });

  const { job } = useCurrentJob();
  const { lead } = useCurrentJobLead();

  const selected = value === interest;

  const maxCreditLine = useMemo(
    () => getMaxCreditLine(rates, job, lead),
    [rates, job, lead],
  );

  const isPreApproved = useMemo(() => getIsPreApproved(rates), [rates]);

  const maxDuration = useMemo(() => getMaxDurationLabel(rates), [rates]);

  const onClick = useCallback(() => {
    setValue('interest', value);
  }, [setValue, value]);

  return {
    selected,
    onClick,
    maxCreditLine,
    maxDuration,
    isPreApproved,
  };
}
